import { render, staticRenderFns } from "./ShowPrice.vue?vue&type=template&id=c8075626&scoped=true&lang=pug"
import script from "./ShowPrice.vue?vue&type=script&lang=js"
export * from "./ShowPrice.vue?vue&type=script&lang=js"
import style0 from "./ShowPrice.vue?vue&type=style&index=0&id=c8075626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8075626",
  null
  
)

export default component.exports